/**
 * Counts whitespace-separated words.
 *
 * Shared with `FetchTextArea`'s built-in counter: the send button and the visible
 * `n/300 words` readout must agree, and two copies of this regex would eventually drift
 * into a state where send is enabled while the counter shows red.
 *
 * @param text - The text to count.
 * @returns The word count; 0 for blank or whitespace-only input.
 */
export function countWords(text: string): number {
  const trimmed = text.trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
}
